import Button from "@mui/material/Button";

const ReturnToProcessButton = ({openDialog, disabled = false}) => {
    const handleDialog = () => {
        openDialog();
    };

    return (
        <Button
            variant="contained"
            color="warning"
            disabled={disabled}
            onClick={handleDialog}
        >
            Devolver para Em Processo
        </Button>
    );
};

export default ReturnToProcessButton;
